import { UserVaultFolders } from './vault.model';

export interface VaultState {
  userId: number | string;
  requestModel: any;
  personalFiles: any;
  sharedFilesInFolders: any;
  sharedSubfolders: any;
  sharedDataWithMe: any;
  sharedDataByMe: any;
  adminAccess: any;
  forms: any;
  categories: any;
  vaultState: any;
  loader: boolean;
  sharedWithMeFolder: any;
  vaults: Array<any[]>;
  vaultId: any;
  vaultName: any;
  formByCategories: Array<any[]>;
  is_personal_files_loading: boolean;
}

export const initialState: VaultState = {
  userId: null,
  requestModel: null,
  personalFiles: null,
  sharedFilesInFolders: null,
  sharedSubfolders: null,
  sharedDataWithMe: null,
  sharedDataByMe: null,
  adminAccess: null,
  forms: null,
  categories: null,
  vaultState: null,
  loader: null,
  sharedWithMeFolder: null,
  vaults: null,
  vaultId: null,
  vaultName: null,
  formByCategories: null,
  is_personal_files_loading: false,
};
